// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TopBar_modal__8y7G3 {
    width: 60vw;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    z-index: 1300;
    transition: transform 0.3s cubic-bezier(.4,0,.2,1);
    transform: translateX(-100%);
}

.TopBar_modalOpen__MEkpj {
    transform: translateX(0);
}`, "",{"version":3,"sources":["webpack://./src/components/TopBar.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,eAAe;IACf,aAAa;IACb,kDAAkD;IAClD,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".modal {\n    width: 60vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: fixed;\n    z-index: 1300;\n    transition: transform 0.3s cubic-bezier(.4,0,.2,1);\n    transform: translateX(-100%);\n}\n\n.modalOpen {\n    transform: translateX(0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `TopBar_modal__8y7G3`,
	"modalOpen": `TopBar_modalOpen__MEkpj`
};
export default ___CSS_LOADER_EXPORT___;
